/** Behaviour Expand/Collapse with Accordion
 *  Extracted and refactored from behaviour.js by Edwin Joassart in october 2020 
 *
 *  Respect the HTML structre below
 *  Build to be backward compatible with NEWS behaviour.js implementation
 *  Tightly coupled to NEWS atomicdesign.css and struture.css
 * 
 *  HTML Structure for an expand collapse is
 * 
 <div class="ep_expand-collapse ep_expand-collapse-accordion" > <!-- ep_expand-collapse-accordion activate accordion mode (only one opened at a time) -->
  <ul>
    <li class="ep_item ep_wrapper-expand-collapse ep_expand"> <!-- ep_expand define which are oppened by default -->
      <h3 class="ep-layout_level2 ep_expand-title">
        <button class="ep_expand-trigger ep_icon-arrow-down align-right"> <!-- icon and align are optionals -->
          <span>Title</span>
        </button>
      </h3>
      <div class="ep_expand-content">
        Content 1
      </div>
    </li>
    <li class="ep_item ep_wrapper-expand-collapse"> <!-- ep_expand define which are oppened by default -->
      <h3 class="ep-layout_level2 ep_expand-title">
        <button class="ep_expand-trigger ep_icon-arrow-down align-right">
          <span>Title Section 2</span>
        </button>
      </h3>
      <div class="ep_expand-content">
        Content 2
        
        <-- Sub expand/collapse works exactly as the top one -->
        <div class="ep_expand-collapse">
           <ul>
            <li class="ep_item ep_wrapper-expand-collapse">
              <h3 class="ep-layout_level2 ep_expand-title">
                <button class="ep_expand-trigger ep_icon-arrow-down align-right"> <!-- icon and align are optionals -->
                  <span>Title</span>
                </button>
              </h3>
              <div class="ep_expand-content">
                Content 2 Sub Content 1
              </div>
            </li>
          </ul>
        </div>
      
        </div>
    </li>
  </ul>

 *
 * Refactoring notes : 
 * - Original was calling init on scroll event ?!
 * - Original had some polyfill for IE. Shouldn't be needed with babel
 * - Accordion is a new feature which didn't exist in original implementation
 * 
 */

const DEFAULT_SELECTOR = '.ep_expand-collapse';

class ExpandCollapse {
  /** Create an Expand Collapse
   * @param {Selector} ECContainer - Selector to the Expand Collapse main div
   */
  constructor(ECContainer) {
    this.ECContainer = ECContainer;
    this.isAccordion = ECContainer.classList.contains(
      'ep_expand-collapse-accordion'
    );
    this.attachEC(this.ECContainer);
  }

  /** Init Expand Collapse For The Container
   * @param {Selector} ECContainer
   */
  attachEC(ECContainer) {
    /*
     * ECs targets ECContainer > ul > li.ep_item
     * It's written like to limit scope when there's nested Expand/Collapse
     */
    const ECs = Array.from(
      ECContainer.querySelector('ul').children
    ).filter((child) => child.classList.contains('ep_item'));

    ECs.forEach((epItem) => {
      if (epItem.classList.contains('ECloaded')) return; // expand already set up

      // open or closed by default
      this.openClose(epItem, {
        opening: epItem.classList.contains('ep_expand'),
        preventAnimation: true, // we don't want to autoscroll on load
      });

      this.attachBtnTrigger(epItem, { isAccordion: this.isAccordion });

      epItem.classList.add('ECloaded');
    });
  }

  /** Attach Event Listener to the button
   * @param {Selector} btn - Selector to the button we'll attach to
   * @param {Selector} target - - Selector to the div for the expand/collapse
   * @param {Object} params - Object w/ EC parameters { isAccordion (bool) }
   */
  attachBtnTrigger(epItem, { isAccordion }) {
    const btn = epItem.querySelector('.ep_expand-trigger');
    if (!btn || btn.classList.contains('has-click-handler')) return;

    btn.classList.add('has-click-handler');

    btn.addEventListener('click', (event) => {
      event.preventDefault();

      const isExpanded = epItem.getAttribute('data-expanded') === 'true';

      if (!isExpanded && isAccordion) {
        // close the open one
        const openedEpItems = this.ECContainer.querySelectorAll(
          '[data-expanded="true"]'
        );
        openedEpItems.forEach((opened) =>
          this.openClose(opened, { opening: false })
        );
      }

      this.openClose(epItem, { opening: !isExpanded });
    });
  }

  /** Open/Close Collapsable
   * @param {Selector} epItem - ? expand-collapse wrapper ?
   * @param {Object} options.opening - direction : true = expanding; false = collapsing
   */
  openClose(epItem, { opening, preventAnimation }) {
    const btn = epItem.querySelector('.ep_expand-trigger');
    const target = epItem.querySelector('.ep_expand-content');
    btn.setAttribute('aria-expanded', opening);
    epItem.dataset.expanded = opening;
    target.hidden = !opening;

    // wait 350ms before scrolling
    if (opening && !preventAnimation)
      setTimeout(
        () =>
          btn.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          }),
        350
      );
  }

  /**
   * Find all dom elements matching our main selector and attach the behaviour
   * @param {DOMSelector} selector - DOM Selector to search for, defaults to DEFAULT_SELECTOR (const)
   */
  static init(selector) {
    document
      .querySelectorAll(selector || DEFAULT_SELECTOR)
      .forEach((ECElement) => new ExpandCollapse(ECElement));
    console.log('expand init : ok');
  }
}

export default ExpandCollapse;
